import React from 'react';
import { MapPinIcon } from 'lucide-react';
export function ServiceAreas() {
  const areas = ['Austin', 'Round Rock', 'Cedar Park', 'Georgetown', 'Pflugerville', 'Lakeway', 'Bee Cave', 'Dripping Springs', 'Kyle', 'Buda', 'Leander', 'Liberty Hill', 'Hutto', 'Taylor', 'Manor'];
  return <section className="py-16 md:py-24 bg-background" data-id="element-258">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        <div className="text-center mb-16" data-id="element-260">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4" data-id="element-261">
            Areas We Serve
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-262">
          {/* Left Side - Areas List */}
          <div className="w-full lg:w-[60%]" data-id="element-263">
            <h3 className="text-2xl font-semibold text-foreground mb-8" data-id="element-264">
              Trusted roofing across Central Texas
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-265">
              {areas.map((area, index) => <div key={index} className="bg-muted text-foreground px-5 py-2.5 rounded-full font-medium text-sm border border-border hover:border-amber-500 hover:text-amber-600 transition-colors cursor-default flex items-center gap-2" data-id="element-266">
                  <MapPinIcon className="h-4 w-4 text-amber-500" data-id="element-267" />
                  {area}
                </div>)}
            </div>
            <p className="mt-8 text-muted-foreground" data-id="element-268">
              Don't see your city listed? Give us a call. We frequently
              accommodate projects in surrounding communities.
            </p>
          </div>

          {/* Right Side - Map Placeholder */}
          <div className="w-full lg:w-[40%]" data-id="element-269">
            <div className="relative w-full aspect-square md:aspect-video lg:aspect-square rounded-2xl overflow-hidden shadow-lg border border-border bg-slate-100 flex items-center justify-center" data-id="element-270">
              {/* Map stylized background */}
              <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMGg0MHY0MEgwVjB6bTIwIDIwYzAgNS41MjMtNC40NzcgMTAtMTAgMTBTMCAyNS41MjMgMCAyMCA0LjQ3NyAxMCAxMCAxMHMxMCA0LjQ3NyAxMCAxMHoiIGZpbGw9IiNlMmU4ZjAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==')] opacity-50" data-id="element-271"></div>

              {/* Map Pins */}
              <div className="absolute top-1/4 left-1/3 animate-bounce" style={{
              animationDelay: '0ms'
            }} data-id="element-272">
                <MapPinIcon className="h-8 w-8 text-amber-500 drop-shadow-md" data-id="element-273" />
              </div>
              <div className="absolute top-1/2 left-1/2 animate-bounce" style={{
              animationDelay: '200ms'
            }} data-id="element-274">
                <MapPinIcon className="h-10 w-10 text-slate-900 drop-shadow-lg" data-id="element-275" />
              </div>
              <div className="absolute bottom-1/3 right-1/4 animate-bounce" style={{
              animationDelay: '400ms'
            }} data-id="element-276">
                <MapPinIcon className="h-8 w-8 text-amber-500 drop-shadow-md" data-id="element-277" />
              </div>
              <div className="absolute top-1/3 right-1/3 animate-bounce" style={{
              animationDelay: '600ms'
            }} data-id="element-278">
                <MapPinIcon className="h-6 w-6 text-amber-500 drop-shadow-md" data-id="element-279" />
              </div>

              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent" data-id="element-280"></div>

              <div className="relative z-10 bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-md border border-slate-200 font-bold text-slate-800" data-id="element-281">
                Central Texas Region
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}